import { render, staticRenderFns } from "./AttendanceVoice.vue?vue&type=template&id=c75b0f2c&scoped=true"
import script from "./AttendanceVoice.vue?vue&type=script&lang=js"
export * from "./AttendanceVoice.vue?vue&type=script&lang=js"
import style0 from "./AttendanceVoice.vue?vue&type=style&index=0&id=c75b0f2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75b0f2c",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QIcon,QMenu,QBtn,QTooltip,QSpinnerBars});
